(() => {
  if (window.PhotoHardware) return;
  const dialogs = new Map();
  const close = () => dialogs.forEach(dialog => { if (dialog.open) dialog.close(); });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-hardware-open], [data-print-info-open]');
    if (!trigger) return;
    const gallery = trigger.closest('photo-gallery');
    let key = trigger.hasAttribute('data-hardware-open') ? 'hardware' : trigger.dataset.printInfoOpen;
    if (key === 'paper') key = trigger.closest('.photo-print')?.dataset.format === 'artist' ? 'paper-artist' : 'paper-lab';
    const template = gallery?.querySelector(key === 'hardware' ? '[data-hardware-dialog-template]' : '[data-print-info-template="' + key + '"]');
    if (!template) return;
    event.preventDefault();
    let dialog = dialogs.get(key);
    if (!dialog) {
      const fragment = template.content.cloneNode(true);
      dialog = fragment.querySelector('dialog');
      document.body.append(fragment);
      dialogs.set(key, dialog);
      const button = dialog.querySelector('[data-hardware-close], [data-print-info-close]');
      button.addEventListener('click', () => dialog.close());
      dialog.addEventListener('cancel', event => { event.preventDefault(); event.stopPropagation(); dialog.close(); });
      dialog.addEventListener('close', () => {
        const saved = dialog.printOrigin;
        dialog.printOrigin = null;
        if (!saved) return;
        saved.trigger.focus({preventScroll:true});
        window.scrollTo({left:saved.x,top:saved.y,behavior:'instant'});
        saved.wrapper?.scrollTo({left:saved.left,top:saved.top,behavior:'instant'});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          dialog.close();
          return;
        }
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button,a[href]')];
        const index = controls.indexOf(document.activeElement);
        event.preventDefault();
        controls[(index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length].focus();
      });
    }
    const wrapper = gallery.closest('.page-wrapper');
    dialog.printOrigin = {trigger,wrapper,x:window.scrollX,y:window.scrollY,top:wrapper?.scrollTop||0,left:wrapper?.scrollLeft||0};
    dialog.showModal();
    dialog.querySelector('[data-hardware-close], [data-print-info-close]').focus({preventScroll:true});
  });
  window.PhotoHardware = {close};
})();
